export const toggleDatasource = index => ({
  type: "TOGGLE_DATASOURCE",
  index
});
export const hideDatasource = () => ({
  type: "HIDE_DATASOURCE"
});
